import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStateList extends Layout {
    labelSearchStates: Label;
    sourceStates: DataSource;
    tablesourceStateList: Table;
}
